<!-- src/components/Tools/TableOfContents.vue -->
<template>
  <ul class="toc-root">
    <TocNode
      v-for="item in toc"
      :key="item.id"
      :item="item"
      :level="1"
      :is-open="isOpen(item.id)"
      :toggle="toggle"
      :accordion-first-level="accordionFirstLevel"
      :is-open-fn="isOpen"
    />
  </ul>
</template>

<script>
import TocNode from './TocNode.vue';

export default {
  name: 'TableOfContents',
  components: { TocNode },
  props: {
    toc: { type: Array, required: true },
    accordionFirstLevel: { type: Boolean, default: true },
  },
  data() {
    return { openSet: new Set() };
  },
  methods: {
    isOpen(id) { return this.openSet.has(id); },
    toggle(item, level) {
      const id = item.id;
      if (this.openSet.has(id)) this.openSet.delete(id);
      else {
        if (this.accordionFirstLevel && level === 1) {
          this.toc.map(n => n.id).forEach(fid => this.openSet.delete(fid));
        }
        this.openSet.add(id);
      }
      this.openSet = new Set(this.openSet); // forzar reactividad
    },
  },
};
</script>

<style scoped>
    .toc-root,
    .toc-root ul {
    list-style: none;
    padding-left: 0.75rem;
    margin: 0;
    }

    .toc-root a,
    .toc-root a:visited,
    .toc-root a:active,
    .toc-root a:hover,
    .toc-root a:focus {
    color: var(--bs-link-color, #0d6efd); /* siempre azul */
    text-decoration: none !important;     /* quita la línea en TODOS los estados */
    background: none !important;          /* evita subrayados raros por accesibilidad */
    outline: none !important;             /* quita contorno azul al hacer click */
    }
    

    /* transición colapsable */
    .collapse-enter-active,
    .collapse-leave-active { transition: height 180ms ease, opacity 180ms ease; }
    .collapse-enter-from,
    .collapse-leave-to { height: 0; opacity: 0; }
    .collapse-enter-to,
    .collapse-leave-from { height: auto; opacity: 1; }
</style>
